import { PipeTransform } from '@angular/core';
import { StringHelper } from '../../../../helpers/string-helper';

export abstract class LabelOrAlternativePipe implements PipeTransform {
  constructor(readonly alternativeOrdinal: number) {}

  transform(
    ordinal: number,
    label: string,
    alternative: string,
    ifAlternativeEmpty = 'Geen informatie'
  ) {
    if (ordinal == null) {
      return ifAlternativeEmpty;
    }
    if (ordinal === this.alternativeOrdinal) {
      return StringHelper.isEmpty(alternative)
        ? ifAlternativeEmpty
        : alternative;
    }
    return label;
  }
}
